import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-patient-opcards',
  templateUrl: './patient-opcards.component.html',
  styleUrls: ['../patient-profile/patient-profile.component.scss', './patient-opcards.component.scss']
})
export class PatientOpcardsComponent implements OnInit {

  id:any = 0;

  data:any = {list:[], loggedInUser:0}
  constructor(private router:Router, private route: ActivatedRoute, private dataService: DataService) { }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
    this.loadData();
  }

  loadData(){
    this.dataService.getClientOpCards(this.id).subscribe( (data: any[] )=> {
      this.data = data;
    });
  }

}
